export const fileTypeList = [
  {
    label: 'PDF',
    value: 'pdf',
    color: 'red.400',
  },
  {
    label: 'JPEG',
    value: 'jpeg',
    color: 'orange.400',
  },
  {
    label: 'PNG',
    value: 'png',
    color: 'orange.400',
  },
];
